import React, { useEffect, useState } from 'react';
import { Button, Modal, Col, Stack, Row } from 'react-bootstrap';

const TOOTH_SETS = {
    ra_rb_full: [
        "18", "17", "16", "15", "14", "13", "12", "11", "21", "22", "23", "24", "25", "26", "27", "28",
        "55", "54", "53", "52", "51", "61", "62", "63", "64", "65",
        "85", "84", "83", "82", "81", "71", "72", "73", "74", "75",
        "48", "47", "46", "45", "44", "43", "42", "41", "31", "32", "33", "34", "35", "36", "37", "38"
    ],
    ra_rb_dewasa: [
        "18", "17", "16", "15", "14", "13", "12", "11",
        "21", "22", "23", "24", "25", "26", "27", "28",
        "48", "47", "46", "45", "44", "43", "42", "41",
        "31", "32", "33", "34", "35", "36", "37", "38"
    ],
    ra_rb_anak: [
        "55", "54", "53", "52", "51", "61", "62", "63", "64", "65",
        "85", "84", "83", "82", "81", "71", "72", "73", "74", "75"
    ],
    ra_dewasa_anak: [
        "18", "17", "16", "15", "14", "13", "12", "11", "21", "22", "23", "24", "25", "26", "27", "28",
        "55", "54", "53", "52", "51", "61", "62", "63", "64", "65"
    ],
    ra_dewasa: [
        "18", "17", "16", "15", "14", "13", "12", "11", "21", "22", "23", "24", "25", "26", "27", "28"
    ],
    ra_anak: [
        "55", "54", "53", "52", "51", "61", "62", "63", "64", "65"
    ],
    rb_dewasa_anak: [
        "85", "84", "83", "82", "81", "71", "72", "73", "74", "75",
        "48", "47", "46", "45", "44", "43", "42", "41", "31", "32", "33", "34", "35", "36", "37", "38"
    ],
    rb_dewasa: [
        "48", "47", "46", "45", "44", "43", "42", "41", "31", "32", "33", "34", "35", "36", "37", "38"
    ],
    rb_anak: [
        "85", "84", "83", "82", "81", "71", "72", "73", "74", "75"
    ],
    regio_1: [
        "18", "17", "16", "15", "14", "13", "12", "11"
    ],
    regio_2: [
        "21", "22", "23", "24", "25", "26", "27", "28"
    ],
    regio_3: [
        "31", "32", "33", "34", "35", "36", "37", "38"
    ],
    regio_4: [
        "48", "47", "46", "45", "44", "43", "42", "41"
    ],
    regio_5: [
        "55", "54", "53", "52", "51"
    ],
    regio_6: [
        "61", "62", "63", "64", "65"
    ],
    regio_7: [
        "71", "72", "73", "74", "75"
    ],
    regio_8: [
        "85", "84", "83", "82", "81"
    ]
};


function ProtesaMaterialButtonModal({
    getDataDentalProtesaMaterial,
    cleanedTooth,
    toothProtesaMaterial,
    setToothProtesaMaterial,
    selectedTeeth,
    setSelectedTeeth,
    setSelectedTooth,
    activeProtesaMaterialSelections,
    setActiveProtesaMaterialSelections,
    tempProtesaMaterialSelections,
    setTempProtesaMaterialSelections,
    activeMode,
    setActiveMode,
    buttonChoiceRestoration,
    setButtonChoiceRestoration,
    buttonChoiceCondition,
    setButtonChoiceCondition,
    buttonChoiceRestorationMaterial,
    setButtonChoiceRestorationMaterial,
    buttonChoiceProtesa,
    setButtonChoiceProtesa,
    buttonChoiceProtesaMaterial,
    setButtonChoiceProtesaMaterial,
    shouldPromptRestoration,
    setShouldPromptRestoration,
    shouldPromptCondition,
    setShouldPromptCondition,
    shouldPromptRestorationMaterial,
    setShouldPromptRestorationMaterial,
    shouldPromptProtesa,
    setShouldPromptProtesa,
    shouldPromptProtesaMaterial,
    setShouldPromptProtesaMaterial,
    protesaMaterialData,
    setProtesaMaterialData,
    protesaMaterialGigiColor,
    choiceToothCategory,
    openModalType,
    openModal,
    closeModal,
}) {
    const orangeColor = '#fd7e14';
    const showModal = openModalType === 'protesa_material';
    const sourceData = getDataDentalProtesaMaterial;

    const [hasClickedProtesaMaterial, setHasClickedProtesaMaterial] = useState(false);

    const MODE = {
        KONDISI: 'kondisi',
        RESTORASI: 'restorasi',
        BAHAN: 'bahan',
        PROTESA: 'protesa',
        PROTESAMATERIAL: 'protesa_material'
    };

    const handleProtesaMaterialClick = () => {
        if (!cleanedTooth) return;

        const materialIds = toothProtesaMaterial[cleanedTooth] || [];
        const shouldPrompt = materialIds.length === 0;

        setShouldPromptProtesaMaterial(shouldPrompt);
        setTempProtesaMaterialSelections(
            sourceData
                .filter(item => materialIds.includes(item.id))
                .map(item => ({ id: item.id, label: item.display_name }))
        );

        if (shouldPrompt && protesaMaterialGigiColor === 'orange') {
            openModal('protesa_material');
        }

        setActiveMode(MODE.PROTESAMATERIAL);
    };

    const applyToSingleTooth = () => {
        const ids = tempProtesaMaterialSelections.map(s => s.id);
        setActiveProtesaMaterialSelections(ids);

        setToothProtesaMaterial(prev => {
            const updated = { ...prev };
            selectedTeeth.forEach(tooth => {
                updated[tooth] = [...ids];
            });
            return updated;
        });

        setProtesaMaterialData(prev => {
            const filtered = prev.filter(item => !selectedTeeth.includes(item.tooth));
            const newData = selectedTeeth.map(tooth => ({
                tooth,
                materials: [...ids],
            }));
            return [...filtered, ...newData];
        });

        selectedTeeth.forEach(tooth => {
            const polygons = document.querySelectorAll(`[data-nomor-gigi="${tooth}"]`);
            polygons.forEach(p => {
                p.style.setProperty('fill', orangeColor, 'important');
            });
        });

        closeModal();
        setSelectedTeeth([]);
    };


    const applyToTeeth = (teethList) => {
        const ids = tempProtesaMaterialSelections.map(s => s.id);

        setSelectedTooth(teethList); // update selected teeth

        // Hapus semua kondisi lama yang tidak termasuk dalam teethList
        setProtesaMaterialData(prev => {
            const newData = teethList.map(tooth => ({
                tooth,
                protesa_materials: [...ids],
            }));
            return newData;
        });

        // Perbarui state kondisi gigi
        setToothProtesaMaterial(prev => {
            const updated = {};
            teethList.forEach(tooth => {
                updated[tooth] = [...ids];
            });
            return updated;
        });

        // Warnai odontogram
        teethList.forEach(tooth => {
            const polygons = document.querySelectorAll(`[data-nomor-gigi="${tooth}"]`);
            polygons.forEach(p => {
                p.style.setProperty('fill', '#17cfc4', 'important');
            });
        });

        closeModal();
    };

    useEffect(() => {
        selectedTeeth.forEach(tooth => {
            const protesa_material = toothProtesaMaterial[tooth] || [];
            const polygons = document.querySelectorAll(`[data-nomor-gigi="${tooth}"]`);
            const warna = protesa_material.length > 0 ? orangeColor : 'white';
            polygons.forEach(p => {
                p.style.setProperty('fill', warna, 'important');
            });
        });
    }, [toothProtesaMaterial, selectedTeeth]);

    return (
        <>
            <Col>
                <Stack>
                    <Button
                        size="sm"
                        onClick={() => {
                            setButtonChoiceCondition(false);
                            setButtonChoiceRestoration(false);
                            setButtonChoiceRestorationMaterial(false);
                            setButtonChoiceProtesa(false);
                            setButtonChoiceProtesaMaterial(true);
                            setHasClickedProtesaMaterial(true);

                            const isOtherButtonsInactive = !buttonChoiceRestoration && !buttonChoiceCondition && !buttonChoiceProtesa && !buttonChoiceRestorationMaterial && buttonChoiceProtesaMaterial;

                            if (isOtherButtonsInactive && buttonChoiceProtesaMaterial) {
                                handleProtesaMaterialClick();
                                setShouldPromptProtesaMaterial(true);

                                if (
                                    ['ra_rb_full', 'ra_rb_dewasa', 'ra_rb_anak', 'ra_dewasa_anak', 'ra_dewasa', 'ra_anak', 'rb_dewasa_anak', 'rb_dewasa', 'rb_anak', 'regio_1', 'regio_2', 'regio_3', 'regio_4', 'regio_5', 'regio_6', 'regio_7', 'regio_8'].includes(choiceToothCategory)
                                ) {
                                    openModal('protesa_material');
                                }
                            }
                        }}
                    >
                        {!buttonChoiceProtesaMaterial
                            ? "Bahan Protesa"
                            : (shouldPromptProtesaMaterial && !shouldPromptCondition && !shouldPromptProtesa && !shouldPromptRestoration && !shouldPromptRestorationMaterial && hasClickedProtesaMaterial
                                ? "Pilih odontogram dibawah"
                                : "Klik untuk memilih odontogram")}
                    </Button>
                </Stack>
            </Col>

            {shouldPromptProtesaMaterial && (
                <Modal size="lg" show={showModal} onHide={closeModal} centered>
                    <Modal.Header closeButton>
                        <strong>Pilih Protesa Material Gigi</strong>
                    </Modal.Header>
                    <Modal.Body
                        className="text-center"
                        style={{
                            border: `2px solid ${orangeColor}`,
                            color: '#000',
                            borderRadius: '6px',
                            padding: '20px',
                        }}
                    >
                        <Row className="justify-content-center">
                            {sourceData?.map(item => {
                                const isChecked = tempProtesaMaterialSelections.some(sel => sel.id === item.id);
                                return (
                                    <Col key={item.id} md={4} className="mb-2 d-flex justify-content-center">
                                        <Button
                                            size="sm"
                                            onClick={() => {
                                                setTempProtesaMaterialSelections(prev => {
                                                    const exists = prev.some(sel => sel.id === item.id);
                                                    return exists
                                                        ? prev.filter(sel => sel.id !== item.id)
                                                        : [...prev, { id: item.id, label: item.display_name }];
                                                });
                                            }}
                                            className="w-100"
                                            style={{
                                                backgroundColor: isChecked ? orangeColor : 'transparent',
                                                color: '#000000',
                                                borderColor: orangeColor,
                                                borderWidth: '1px',
                                                borderStyle: 'solid',
                                                borderRadius: '6px',
                                                padding: '6px 12px',
                                                fontWeight: 500,
                                            }}
                                        >
                                            {item.display_name}
                                        </Button>
                                    </Col>
                                );
                            })}
                        </Row>

                        <div className="d-flex justify-content-end mt-3">
                            <Button
                                size="sm"
                                onClick={() => {
                                    if (typeof choiceToothCategory === 'string' && TOOTH_SETS[choiceToothCategory]) {
                                        applyToTeeth(TOOTH_SETS[choiceToothCategory]);
                                    } else {
                                        applyToSingleTooth();
                                    }
                                }}
                            >
                                Pilih
                            </Button>
                        </div>
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
}

export default ProtesaMaterialButtonModal;
